import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message } from 'semantic-ui-react'
import { Button } from 'semantic-ui-react'
import _ from 'lodash';
//utils
import queries from '../../../utils/queries'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import updColeccMANY from '../../../functions/updColeccMANY';
import argsHc from '../../../functions/argshc';

// "use strict";

class ProcAdmCC extends React.Component {
  state={opciones: "opcion1", permiteUpdate: true, confirmaAct: false, open: false, errors: []}

  //ACTUALIZAR BD
  crudBD = async (operacionCRUD, args, i)=>{
  // console.log("CRUD")
    if(args.ctrlCampo === 'CRUD'){
      // console.log(i)
      // console.log(args)
      const {data} = await operacionCRUD({
        variables: args
      });

      //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        // console.log("MANY")
        // console.log(args)
        await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    // console.log(argsCrud)
    // console.log(totDocCRUD)
    let codigo = 0
    // console.log(argsCrud)
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    // console.log("inicio")
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
    console.log("final")
  }

  handleChange = (ev) => {
    if(ev.target.name==="opciones"){
      if(ev.target.checked===true){
        this.setState({opciones: ev.target.value})
      }
    }
  }

  handleSubmit = async (ev)=>{
    document.body.style.cursor = 'wait'

    let contrato = document.getElementById("contrato").value;
    let contratoNvo = document.getElementById("contratoNvo").value;
// console.log(contrato, contratoNvo)

    let cambiar = true
    let argsBuscarCL = {}
    let argsBuscarCLNvo = {}

    if(contrato===""||contratoNvo===""){
      cambiar = false
      alert(`Por favor escriba los dos contratos`)
    }

    if(this.props.allCliBasico.allCliBasico&&cambiar){
      argsBuscarCL.contrato = contrato
      if(this.props.codigoCiudadUA!=="Todas..."){
        argsBuscarCL.nombreCiudad=this.props.args.nombreCiudad
      }

      await this.props.allCliBasico.refetch(argsBuscarCL)
      // console.log(this.props.allCliBasico.allCliBasico)
// console.log(argsBuscarCL)
      if(this.props.allCliBasico.allCliBasico.length===0){
        cambiar = false
        if(this.props.codigoCiudadUA!=="Todas..."){
          alert(`El contrato ${contrato} NO existe en la ciudad de ${this.props.args.nombreCiudad}`)
        }else{
          alert(`El contrato ${contrato} NO existe`)
        }
      }

      argsBuscarCLNvo.contrato = contratoNvo
      argsBuscarCLNvo.nombreCiudad=null
      await this.props.allCliBasico.refetch(argsBuscarCLNvo)
      // console.log(this.props.allCliBasico.allCliBasico)
// console.log(argsBuscarCLNvo)
      if(this.props.allCliBasico.allCliBasico.length>0){
        cambiar = false
        alert(`El contrato ${contratoNvo} YA existe`)
      }
    }else{
      cambiar = false
    }

    if(cambiar){
      let actCli = []
      let argsUpd = {}
      argsUpd = {
        "tipoAct": "EditarContrato",
        "contrato": contrato,
        "contratoNvo": contratoNvo
      }
      actCli.push(argsUpd)

      //Actualizar BD
      // let numDocCRUD = 0
      let totDocCRUD = 12
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editHistCliente)
        crudColecc.push(this.props.editAjuste)
        crudColecc.push(this.props.editCargoEsp)
        crudColecc.push(this.props.editDetalleDX)
        crudColecc.push(this.props.editFacturacion)
        crudColecc.push(this.props.editMovCliCC)
        crudColecc.push(this.props.editMovClientes)
        crudColecc.push(this.props.editNotasDebCre)
        crudColecc.push(this.props.editOdeSContr)
        crudColecc.push(this.props.editEquipo)
        crudColecc.push(this.props.editPagoClientes)
        crudColecc.push(this.props.editCliente)

        argsCrud[iii] = actCli[0]
        argsCrud[iii]['ctrlCampo'] = 'CRUD'
        argsCrud[iii]['ctrl_id'] = 'NO_ID'
      }

      // console.log(argsCrud, crudColecc)
      await this.updColecc(crudColecc, argsCrud, totDocCRUD)

      //Coleccion HISTCLIENTES
      // //Documento para coleccion
      let userLogin = sessionStorage.getItem('userLogin')
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha

      let relacion = "0", movimiento = "Cambio", detalle = `${contrato} => ${contratoNvo}`, valor = 0
      let descripcion = "Cambio contrato"

      let colecc = argsHc(contratoNvo, relacion, valor, userLogin, descripcion, detalle, movimiento, fechaHoraHoy)
      let creaColecc = colecc.creaColecc
      // console(colecc.creaColecc)
      // Actualizar base de datos
      let creaColeccMany = [], creaColeccMany1 = []
      creaColecc.forEach((elemento, ii) => {
        creaColeccMany.push(elemento)
      })
      creaColeccMany1.push({histcliente: creaColeccMany})
      let updColMANY = updColeccMANY(creaColeccMany1, this.props.createHistClienteMany)
      await this.updColecc(updColMANY.crudColecc, updColMANY.argsCrud, updColMANY.totDocCRUD)
      //FIN Coleccion HISTCLIENTES

      contrato = document.getElementById("contrato");
      contrato.value = ""
      contratoNvo = document.getElementById("contratoNvo");
      contratoNvo.value = ""
    }

    document.body.style.cursor = 'default'
  }


  handleSubmitcc = async (ev)=>{
    document.body.style.cursor = 'wait'

    let listCli = [], listCliCli = []
    // let nuevo = 1
    let nuevo = 10000
    // Va hasta el 4448
    if(this.props.allCliBasico.allCliBasico){
      // listCli = [
      //   {actual: '0152', nuevo: '10000'},
      //   {actual: '0153', nuevo: '10001'},
      //   {actual: '0633', nuevo: '10002'},
      //   {actual: '8233', nuevo: '10283'},
      //   {actual: '8248', nuevo: '10284'},
      //   {actual: '8249', nuevo: '10285'},
      //   ]

      let argsBuscarCL = {}
      argsBuscarCL.contrato = null
      let {data} = await this.props.allCliBasico.refetch(argsBuscarCL)
      listCliCli = await data.allCliBasico
      // listCliCli = _.orderBy(listCliCli, ['fechaCreacionSistema', 'fechaPrimeraActivacion', 'contrato'], ['asc', 'asc', 'asc'])
      // listCliCli = _.orderBy(listCliCli, ['contrato'], ['asc'])
      console.log(listCliCli.length)
      for(let iii=0; iii<listCliCli.length; iii++){
        if(listCliCli[iii].descrNodo!==""&&listCliCli[iii].contrato!==listCliCli[iii].descrNodo){
          listCli.push({actual: listCliCli[iii].contrato, nuevo: listCliCli[iii].descrNodo})
          nuevo += 1
        }
      }
      console.log(listCli)
      console.log(argsBuscarCL)

      let desde = 0
      let hasta = 3000

      // let desde = 1001
      // let hasta = 2000

      // let desde = 2001
      // let hasta = 3000

      // let desde = 3001
      // let hasta = 4000

      // let desde = 4001
      // let hasta = 5000

      // let desde = 5001
      // let hasta = 6000
      
      // let desde = 6001
      // let hasta = 7000
      
      // let desde = 7001
      // let hasta = 8000
      
      // let desde = 8001
      // let hasta = 9000
      
      // let desde = 9001
      // let hasta = 10000
      
      // let desde = 10001
      // let hasta = 11000
      
      // let desde = 11001
      // let hasta = 12000

    // listCli.forEach(async (elemento1, iii) => {
      for(let iii=desde; iii<=hasta; iii++){
        if(iii<listCli.length){
        let elemento1 = listCli[iii]

      let cambiar = false
    let contrato = ""
    let contratoNvo = ""
    // if(elemento1.dirmayor.ciudades&&elemento1.contrato.substr(0, 3)==="0-I"){
    if(elemento1){

      cambiar = true
      // contrato = elemento1.contrato
      contrato = elemento1.actual

      // if(elemento1.dirmayor.ciudades.nombreCiudad==="PASTO"){
      //   contratoNvo = "99" + elemento1.contrato
      // }
      // if(elemento1.dirmayor.ciudades.nombreCiudad==="BARRANQUILLA"){
      //   contratoNvo = "77" + elemento1.contrato
      // }
      // if(elemento1.dirmayor.ciudades.nombreCiudad==="SOLEDAD"){
      //   contratoNvo = "77" + elemento1.contrato
      // }
      // if(elemento1.dirmayor.ciudades.nombreCiudad==="PASTO"||
      //     elemento1.dirmayor.ciudades.nombreCiudad==="PASTO EL PILAR"||
      //     elemento1.dirmayor.ciudades.nombreCiudad==="PASTO CHAMBU"||
      //     elemento1.dirmayor.ciudades.nombreCiudad==="PASTO SANTA MONICA"||
      //     elemento1.dirmayor.ciudades.nombreCiudad==="PASTO SAN VICENTE"||
      //     elemento1.dirmayor.ciudades.nombreCiudad==="PASTO INTERNET DESARROLLO"){
      //   contratoNvo = "99" + elemento1.contrato
      // }else{
      //   contratoNvo = "77" + elemento1.contrato
      // }
      // contratoNvo = "99" + elemento1.contrato.substr(3)
      contratoNvo = elemento1.nuevo

      argsBuscarCL.contrato = contratoNvo
      await this.props.allCliBasico.refetch(argsBuscarCL)
      if(this.props.allCliBasico.allCliBasico.length>0){
        // if(elemento1.dirmayor.ciudades.nombreCiudad==="PASTO"||
        //     elemento1.dirmayor.ciudades.nombreCiudad==="PASTO EL PILAR"||
        //     elemento1.dirmayor.ciudades.nombreCiudad==="PASTO CHAMBU"||
        //     elemento1.dirmayor.ciudades.nombreCiudad==="PASTO SANTA MONICA"||
        //     elemento1.dirmayor.ciudades.nombreCiudad==="PASTO SAN VICENTE"||
        //     elemento1.dirmayor.ciudades.nombreCiudad==="PASTO INTERNET DESARROLLO"){
        //   contratoNvo = "999" + elemento1.contrato
        // }else{
        //   contratoNvo = "777" + elemento1.contrato
        // }
        // contratoNvo = "999" + elemento1.contrato.substr(3)
        contratoNvo = contrato
console.log("YA EXISTE", contratoNvo, contrato)
        argsBuscarCL.contrato = contratoNvo
        await this.props.allCliBasico.refetch(argsBuscarCL)
        if(this.props.allCliBasico.allCliBasico.length>0){
          cambiar = false
          // console.log("OJOOOOOO", iii, contrato, contratoNvo, elemento1.dirmayor.ciudades.nombreCiudad)
          console.log("OJOOOOOO", iii, contrato, contratoNvo)
        }else{
          // console.log("NUEVOOOOOO", iii, contrato, contratoNvo, elemento1.dirmayor.ciudades.nombreCiudad)
          console.log("NUEVOOOOOO", iii, contrato, contratoNvo)
        }
      }
    }


    if(cambiar){
      // console.log(iii, contrato, contratoNvo, elemento1.dirmayor.ciudades.nombreCiudad)
      console.log(iii, contrato, contratoNvo)

      let actCli = []
      let argsUpd = {}
      argsUpd = {
        "tipoAct": "EditarContrato",
        "contrato": contrato,
        "contratoNvo": contratoNvo
      }
      actCli.push(argsUpd)

      //Actualizar BD
      // let numDocCRUD = 0
      let totDocCRUD = 12
      let argsCrud = []
      let crudColecc = []
      for(let iiii=0; iiii<totDocCRUD; iiii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iiii=0; iiii<totDocCRUD; iiii++){
        crudColecc.push(this.props.editHistCliente)
        crudColecc.push(this.props.editAjuste)
        crudColecc.push(this.props.editCargoEsp)
        crudColecc.push(this.props.editDetalleDX)
        crudColecc.push(this.props.editFacturacion)
        crudColecc.push(this.props.editMovCliCC)
        crudColecc.push(this.props.editMovClientes)
        crudColecc.push(this.props.editNotasDebCre)
        crudColecc.push(this.props.editOdeSContr)
        crudColecc.push(this.props.editEquipo)
        crudColecc.push(this.props.editPagoClientes)
        crudColecc.push(this.props.editCliente)

        argsCrud[iiii] = actCli[0]
        argsCrud[iiii]['ctrlCampo'] = 'CRUD'
        argsCrud[iiii]['ctrl_id'] = 'NO_ID'
      }

      // console.log(argsCrud, crudColecc)
      await this.updColecc(crudColecc, argsCrud, totDocCRUD)

      //Coleccion HISTCLIENTES
      // //Documento para coleccion
      let userLogin = sessionStorage.getItem('userLogin')
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha

      let relacion = "0", movimiento = "Cambio", detalle = `${contrato} => ${contratoNvo}`, valor = 0
      let descripcion = "Cambio contrato"

      let colecc = argsHc(contratoNvo, relacion, valor, userLogin, descripcion, detalle, movimiento, fechaHoraHoy)
      let creaColecc = colecc.creaColecc
      // console(colecc.creaColecc)
      // Actualizar base de datos
      let creaColeccMany = [], creaColeccMany1 = []
      creaColecc.forEach((elemento, ii) => {
        creaColeccMany.push(elemento)
      })
      creaColeccMany1.push({histcliente: creaColeccMany})
      let updColMANY = updColeccMANY(creaColeccMany1, this.props.createHistClienteMany)
      await this.updColecc(updColMANY.crudColecc, updColMANY.argsCrud, updColMANY.totDocCRUD)
      //FIN Coleccion HISTCLIENTES

      // contrato = document.getElementById("contrato");
      // contrato.value = ""
      // contratoNvo = document.getElementById("contratoNvo");
      // contratoNvo.value = ""
    }
  }
}
  // })
}
    document.body.style.cursor = 'default'
  }


  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {permiteUpdate, confirmaAct, open, errors} = this.state;

    let mensaje = "CAMBIAR NUMERO DE CONTRATO"
    let imgIcon = "images/archivo_32.png"

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large edit yellow icon"></i>
            Cambiar número de contrato
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev):()=>{}}>
              <div>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <h1 style={{color: '#2C7744'}}>Cambiar número de contrato</h1>
                    </div>
                  </div>
                </div>
                <hr></hr>

                <Form.Field>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Contrato
                        </label>
                        <input autoFocus style={this.props.styles.input} autoComplete="off" name="contrato" id="contrato" onChange={this.handleChange} placeholder='Contrato'/>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Contrato NUEVO
                        </label>
                        <input autoFocus style={this.props.styles.input} autoComplete="off" name="contratoNvo" id="contratoNvo" onChange={this.handleChange} placeholder='Contrato NUEVO'/>
                      </div>
                    </div>
                  </div>
                </Form.Field>
                <hr></hr>
                <div className="ui three column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                    </div>
                  </div>
                </div>
                <hr></hr>

                {/* <div className="column" style={{width: '25%'}}>
                  <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmitcc(ev)} fluid>
                    CAMBIO MASIVO DE NUMERO DE CONTRATO
                  </Button>
                </div> */}


              </div>
              {
                errors.length?<Message negative header="Los siguientes errores:"
                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
              }
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allCliBasico, {name:'allCliBasico', options: (props) => {return {variables: {contrato: "XYZ321"}}}}),

  graphql(queries.mutation.editCliente, {name:'editCliente'}),
  graphql(queries.mutation.editHistCliente, {name:'editHistCliente'}),
  graphql(queries.mutation.editAjuste, {name:'editAjuste'}),
  graphql(queries.mutation.editCargoEsp, {name:'editCargoEsp'}),
  graphql(queries.mutation.editDetalleDX, {name:'editDetalleDX'}),
  graphql(queries.mutation.editFacturacion, {name:'editFacturacion'}),
  graphql(queries.mutation.editMovCliCC, {name:'editMovCliCC'}),
  graphql(queries.mutation.editMovClientes, {name:'editMovClientes'}),
  graphql(queries.mutation.editNotasDebCre, {name:'editNotasDebCre'}),
  graphql(queries.mutation.editOdeSContr, {name:'editOdeSContr'}),
  graphql(queries.mutation.editEquipo, {name:'editEquipo'}),
  graphql(queries.mutation.editPagoClientes, {name:'editPagoClientes'}),

  graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
)(ProcAdmCC)
